import { modal } from "../common/modal";
import { callable } from "../common/userAgent"
import { googleAnalytics } from "../lib/googleAnalytics";
import masterData from "../lib/masterData";
import { isBetsukanriInHokkaido } from "../lib/isBetsukanriInHokkaido"

export const callTracking = (contactType, eventTrackingId) => {
  if (window.yahoo_report_conversion && window.goog_report_conversion) {
    // Yahoo! Google!両方の場合は、Yahooはダミーにしないといけない
    yahoo_report_conversion(undefined);
    goog_report_conversion(contactType.phoneUrl);
  } else if (window.yahoo_report_conversion) {
    yahoo_report_conversion(contactType.phoneUrl);
  } else if (window.goog_report_conversion) {
    goog_report_conversion(contactType.phoneUrl);
  } else {
    console.log("report_conversion library not found", contactType.phoneUrl);
  }
  googleAnalytics.click({ label: eventTrackingId, action: contactType.slug })
};

export const openPhonecall = (contactTypeSlug, eventTrackingId, asset, room) => {
  let contactType = masterData.contactType.bySlug[contactTypeSlug];
  if (asset) {
    if (isBetsukanriInHokkaido(asset)) {
      contactType = masterData.contactType.bySlug["hokkaido2"];
    }
  }
  if (!callable) {
    modal.openModal("modal_phone_call", {
      contactType,
      eventTrackingId,
      asset,
      room,
    });
  } else {
    location.href = contactType.phoneUrl;
  }
  callTracking(contactType, eventTrackingId)
};

export const openContact = (contactTypeSlug, { eventTrackingId, asset, room }) => {
  const contactType = masterData.contactType.bySlug[contactTypeSlug];
  if (contactType.showForm || contactType.showChat || contactType.showCorporateLink || contactType.showAdviceCard) {
    // 選択ダイアログ
    modal.openModal("modal_howto_contact", { contactType, eventTrackingId, asset, room });
  } else if (contactType.phoneNumber) {
    // 直接電話番号を開く
    openPhonecall(contactTypeSlug, eventTrackingId, asset, room);
  } else if (contactType.url) {
    // 直接外部リンクを開く
    window.open(contactType.url, '_blank');
  }
}

export const getPhoneNumber = (contactTypeSlug) => {
  const contactType = masterData.contactType.bySlug[contactTypeSlug];
  return contactType.phoneNumber;
}

const biztelMode = true;

export const openContactSelector = ({ eventTrackingId, asset, room }) => {
  if (biztelMode) {
    modal.openModal("modal_type_contact", { eventTrackingId, asset, room })
  } else {
    const contactType = masterData.contactType.bySlug.all_main;
    modal.openModal("modal_howto_contact", { contactType, eventTrackingId, asset, room });
  }
}

export const openReservation = ({ eventTrackingId, asset, room }) => {
  modal.openModal("modal_reservation", { eventTrackingId, asset, room })
}




// WEBPACK FOOTER //
// ./common/callUtil.js